import React from 'react'

const SvgBalanceOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 2a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2H4zm16 2H4v16h16V4z'
    />
    <path d='M10.213 10.465c.229-.484.434-.919.434-1.641a2.824 2.824 0 00-5.647 0c0 1.127.369 3.576.84 5.647h3.837c-.247-2.35.174-3.24.536-4.006zM9.877 15.882h-3.68c.07.253.143.49.215.706.156.47.706 1.412 1.764 1.412 1.06 0 1.807-1.059 1.765-1.765l-.064-.353zM13.834 10.465c-.228-.484-.434-.919-.434-1.641a2.824 2.824 0 015.647 0c0 1.127-.369 3.576-.84 5.647H14.37c.246-2.35-.175-3.24-.537-4.006zM14.17 15.882h3.68c-.07.253-.143.49-.215.706-.156.47-.706 1.412-1.764 1.412-1.06 0-1.807-1.059-1.765-1.765.023-.12.044-.238.064-.353z' />
  </svg>
)

export default SvgBalanceOutline
